import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { bodyId: String }

  connect() {
    this.body = document.getElementById(this.bodyIdValue)
  }

  toggle() {
    if (!this.body) return
    const collapsed = this.body.classList.toggle("d-none")
    this.element.classList.toggle("collapsed", collapsed)
  }
}
